<script>
    import { isActive, page, url, redirect } from '@sveltech/routify'
    import AuthService from '../helpers/AuthService'
    import Transition from 'svelte-class-transition'

    export let profileImage = '/'
    let pages = [
        ['./index', 'Home'],
        ['./chat', 'Chat Settings'],
        ['./hype', 'Hype Train Settings'],
    ]
    let isNavOpen = false
    let isMenuOpen = false

    function toggleSideNav() {
        isNavOpen = !isNavOpen
    }

    function toggleMenu() {
        isMenuOpen = !isMenuOpen
    }

    async function logout() {
        const res = await AuthService.logout()
        const tokenExists = await AuthService.getToken()

        if (!tokenExists) {
            return $redirect('/')
        }
        return res
    }
</script>

<div class="h-screen flex overflow-hidden bg-gray-100">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
    {#if isNavOpen}
        <div class="md:hidden">
            <div class="fixed inset-0 flex z-40" on:click={toggleSideNav}>
                <!--
          Off-canvas menu overlay, show/hide based on off-canvas menu state.
  
          Entering: "transition-opacity ease-linear duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "transition-opacity ease-linear duration-300"
            From: "opacity-100"
            To: "opacity-0"
        -->
                <Transition
                    transitions="transition-opacity"
                    inTransition="ease-linear duration-300"
                    inState="opacity-0"
                    onState="opacity-100"
                    outState="opacity-0">
                    <div class="fixed inset-0">
                        <div class="absolute inset-0 bg-gray-600 opacity-75" />
                    </div>
                </Transition>
                <!--
          Off-canvas menu, show/hide based on off-canvas menu state.
  
          Entering: "transition ease-in-out duration-300 transform"
            From: "-translate-x-full"
            To: "translate-x-0"
          Leaving: "transition ease-in-out duration-300 transform"
            From: "translate-x-0"
            To: "-translate-x-full"
        -->
                <Transition
                    transitions="transition transform"
                    inTransition="ease-in-out duration-300"
                    inState="-translate-x-full"
                    onState="-translate-x-0"
                    outState="-translate-x-full">
                    <div
                        class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-green-900">
                        <div class="absolute top-0 right-0 -mr-14 p-1">
                            <button
                                class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-800"
                                aria-label="Close sidebar">
                                <svg
                                    class="h-6 w-6 text-white"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24">
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div class="flex-shrink-0 flex items-center px-4">
                            <img
                                class="h-12 w-12"
                                alt="Logo"
                                src="./images/hunter-logo.png" />
                            <span
                                class="ml-3 text-xl pb-1 font-semibold text-white">Hunter's
                                Call</span>
                        </div>
                        <div class="mt-5 flex-1 h-0 overflow-y-auto">
                            <nav class="px-2 space-y-1">
                                {#each pages as [path, name]}
                                    <a
                                        href={$url(path)}
                                        class="{$isActive(path, true) ? 'nav-btn-selected bg-green-1000' : 'nav-btn'} group flex">
                                        {#if name === 'Home'}
                                            <svg
                                                class="h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                            </svg>
                                        {:else if name === 'Chat Settings'}
                                            <svg
                                                class="h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                                            </svg>
                                        {:else if name === 'Hype Train Settings'}
                                            <svg
                                                class="h-4 w-4"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 32 32">
                                                <path
                                                    id="train"
                                                    d="M10.37872,26h2.90009L12.126,28.42871A1,1,0,0,1,11.22266,29H8.23035a.5.5,0,0,1-.32538-.87964Zm10.8241,0H18.30273l1.15278,2.42871A1,1,0,0,0,20.35889,29H23.3512a.5.5,0,0,0,.32537-.87964ZM25,9V22a2.00006,2.00006,0,0,1-2,2H9a2.00006,2.00006,0,0,1-2-2V9a5.0147,5.0147,0,0,1,5-5h8A5.0147,5.0147,0,0,1,25,9ZM13,17.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5Zm10,0a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5ZM23,9a3.00879,3.00879,0,0,0-3-3H12A3.00879,3.00879,0,0,0,9,9v3a1.00291,1.00291,0,0,0,1,1H22a1.00291,1.00291,0,0,0,1-1Z" />
                                            </svg>
                                        {/if}
                                        {name}
                                    </a>
                                {/each}
                            </nav>
                        </div>
                    </div>
                </Transition>
                <div class="flex-shrink-0 w-14">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </div>
    {/if}

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-64">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex flex-col h-0 flex-1">
                <div
                    class="flex items-center h-16 flex-shrink-0 px-4 bg-green-1000">
                    <img
                        class="h-12 w-12"
                        alt="Logo"
                        src="./images/hunter-logo.png" />
                    <span
                        class="ml-3 text-xl pb-1 font-semibold text-white">Hunter's
                        Call</span>
                </div>
                <div class="flex-1 flex flex-col overflow-y-auto">
                    <nav class="flex-1 px-2 py-4 bg-green-900 space-y-1">
                        {#each pages as [path, name]}
                            <a
                                href={$url(path)}
                                class="{$isActive(path, true) ? 'nav-btn-selected bg-green-1000' : 'nav-btn'} active:bg-green-1000 focus:bg-green-1000 group flex">
                                {#if name === 'Home'}
                                    <svg
                                        class="h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                    </svg>
                                {:else if name === 'Chat Settings'}
                                    <svg
                                        class="h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                                    </svg>
                                {:else if name === 'Hype Train Settings'}
                                    <svg
                                        class="h-4 w-4"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32">
                                        <path
                                            id="train"
                                            d="M10.37872,26h2.90009L12.126,28.42871A1,1,0,0,1,11.22266,29H8.23035a.5.5,0,0,1-.32538-.87964Zm10.8241,0H18.30273l1.15278,2.42871A1,1,0,0,0,20.35889,29H23.3512a.5.5,0,0,0,.32537-.87964ZM25,9V22a2.00006,2.00006,0,0,1-2,2H9a2.00006,2.00006,0,0,1-2-2V9a5.0147,5.0147,0,0,1,5-5h8A5.0147,5.0147,0,0,1,25,9ZM13,17.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5Zm10,0a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5ZM23,9a3.00879,3.00879,0,0,0-3-3H12A3.00879,3.00879,0,0,0,9,9v3a1.00291,1.00291,0,0,0,1,1H22a1.00291,1.00291,0,0,0,1-1Z" />
                                    </svg>
                                {/if}

                                {name}
                            </a>
                        {/each}
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <div class="relative z-10 flex-shrink-0 flex h-16 bg-green-1000 shadow">
            <button
                on:click={toggleSideNav}
                class="px-4 border-r border-green-900 text-gray-400 focus:outline-none focus:bg-green-900 focus:text-gray-200 md:hidden"
                aria-label="Open sidebar">
                <svg
                    class="h-6 w-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 6h16M4 12h16M4 18h7" />
                </svg>
            </button>
            <div class="flex-1 px-4 flex justify-between bg-green-1000">
                <div class="flex-1 flex" />
                <div class="ml-4 flex items-center md:ml-6">
                    <!-- Profile dropdown -->
                    <div class="ml-3 relative" on:click={toggleMenu}>
                        <div>
                            <button
                                class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline"
                                id="user-menu"
                                aria-label="User menu"
                                aria-haspopup="true">
                                <img
                                    class="h-8 w-8 rounded-full"
                                    src={profileImage}
                                    alt="" />
                            </button>
                        </div>
                        <!--
                Profile dropdown panel, show/hide based on dropdown state.
  
                Entering: "transition ease-out duration-100"
                  From: "transform opacity-0 scale-95"
                  To: "transform opacity-100 scale-100"
                Leaving: "transition ease-in duration-75"
                  From: "transform opacity-100 scale-100"
                  To: "transform opacity-0 scale-95"
              -->
                        {#if isMenuOpen}
                            <Transition
                                transitions="transition transform"
                                inTransition="ease-out duration-500"
                                inState="opacity-0 scale-95"
                                onState="opacity-100 scale-100"
                                outState="opacity-0 scale-95"
                                outTransition="ease-in duration-500">
                                <div
                                    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                                    <div
                                        class="py-1 rounded-md bg-white shadow-xs"
                                        role="menu"
                                        aria-orientation="vertical"
                                        aria-labelledby="user-menu">
                                        <a
                                            href={$url('./admin')}
                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                            role="menuitem">Whitelist Settings</a>
                                        <a
                                            href="/"
                                            on:click|preventDefault={logout}
                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                            role="menuitem">Logout</a>
                                    </div>
                                </div>
                            </Transition>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

        <main
            class="flex-1 relative overflow-y-auto focus:outline-none p-8"
            tabindex="0">
            <slot />
        </main>
    </div>
</div>

<style type="text/postcss">
    .nav-btn {
        @apply items-center px-2 py-2 text-sm leading-5 font-medium text-white text-opacity-75 rounded-md transition ease-in-out duration-150;
    }

    .nav-btn:hover {
        @apply text-white bg-green-800 text-opacity-100;
    }

    .nav-btn:focus {
        @apply outline-none text-white text-opacity-100;
    }

    .nav-btn svg {
        @apply mr-3 h-6 w-6;
    }

    .nav-btn-selected {
        @apply items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md transition ease-in-out duration-150;
    }

    .nav-btn-selected:focus {
        @apply outline-none;
    }

    .nav-btn-selected svg {
        @apply mr-3 h-6 w-6 text-white  text-opacity-100 transition ease-in-out duration-150;
    }
</style>
